

let image1 = { src: "https://images.assettype.com/newslaundry/2023-05/02808157-6d2b-4170-8037-a8afc4f527b3/london22.jpeg", text: "London, May 2022" };
let image2 = { src: "https://images.assettype.com/newslaundry/2023-05/e17756fc-0f3b-4d9a-95eb-21a86420586f/sydney.jpeg", text: "Sydney, May 2022" }
let image3 = { src: "https://images.assettype.com/newslaundry/2023-05/c27e3818-6a8f-48db-b1b1-633f4bc6e494/melbourne.jpeg", text: "Melbourne, June 2022" }
let image4 = { src: "https://images.assettype.com/newslaundry/2023-05/79a6f4b5-9300-42c0-a1c0-f5a6d2125b08/mumbai.jpeg", text: "Mumbai, September 2022" }
let image5 = { src: "https://images.assettype.com/newslaundry/2023-05/51a2896c-480f-4206-8b06-6a54c4bd864f/subscribers_meet_up_aug_delhi.jpeg", text: "Delhi, July 2022" };
let image6 = { src: "https://images.assettype.com/newslaundry/2023-05/cdc9fb2e-afaa-4f3a-aa32-bef965e76638/boston.jpeg", text: "Boston, February 2018" };
let image7 = { src: "https://images.assettype.com/newslaundry/2023-05/d039cecc-57e2-4afc-b2be-97b22867a185/michigan.jpeg", text: "Michigan, April 2023" };
let image8 = { src: "https://images.assettype.com/newslaundry/2023-05/c794a363-dfd2-4d73-8b5a-439ca6d83e40/london_meetup_may2023.jpeg", text: "London, May 2023" }
let image9 = { src:"https://images.assettype.com/newslaundry/2023-06/30600284-3857-4f6f-906f-8607710ddbb6/img_2716_2.jpg", text: "Bengaluru, June 2023"}

// whenever we need to add an image in Carousel, 
// make another object with src and text like above 
// and add it to the below array wherever you want to place it in order and then increase the image count in index.js file
 

const images = [image9, image8, image7, image4, image5, image3, image2, image1, image6];

const imageByIndex = (index) => images[index % images.length];

export default imageByIndex;
